import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
import { createRoot } from "react-dom/client";
import App from './App';
import "./i18n.js";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);


root.render(<App />);
